// Generator-discovered file route for the storyboard preview. Component lives in
// `src/ad/routes/storyboard.tsx` (Module K / K3). Reads the `creativeId` search
// param and passes it as a prop.
import { createFileRoute } from '@tanstack/react-router';
import { StoryboardRouteComponent } from '@/ad/routes/storyboard';

function parseCreativeId(search: Record<string, unknown>): { creativeId?: number } {
  const raw = search.creativeId;
  const n = typeof raw === 'number' ? raw : Number(raw);
  return Number.isInteger(n) && n > 0 ? { creativeId: n } : {};
}

export const Route = createFileRoute('/_authenticated/ad/storyboard')({
  validateSearch: parseCreativeId,
  component: StoryboardRoute,
});

function StoryboardRoute(): React.ReactElement {
  const { creativeId } = Route.useSearch();
  return <StoryboardRouteComponent creativeId={creativeId} />;
}
